export { default } from './Home24Canais';
